import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

export default function SuccessPage() {
  const navigate = useNavigate();

  return (
    <main className="flex overflow-hidden flex-wrap gap-10 justify-center items-center px-20 py-10 min-h-screen bg-zinc-50 max-md:px-5">
      <section className="flex flex-col justify-center items-center h-full min-w-60 w-[722px] max-md:max-w-full">
        <header className="w-40 max-w-full mb-16">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/a957b64922e04ac2a23d8b53cd42fbd2/28589217f7c95b3096b1e549983f5afc4d150520?placeholderIfAbsent=true"
            alt="Company logo"
            className="object-contain w-full aspect-[1.76]"
          />
        </header>

        <div className="flex flex-col items-center text-center max-w-[600px]">
          <CheckCircle className="w-20 h-20 text-green-500 mb-6" strokeWidth={1.5} />
          
          <h1 className="text-4xl font-bold text-gray-700 mb-4">
            Formulário Enviado com Sucesso!
          </h1>
          
          <p className="text-lg text-gray-500 mb-10">
            Seu formulário foi recebido e está sendo processado.
          </p>
{/*           
          <div className="flex gap-4">
            <Button 
              variant="default"
              onClick={() => navigate('/')}
              className="flex gap-2.5 items-center justify-center"
            >
              Voltar para o Início
            </Button>
            
            <Button 
              variant="outline"
              onClick={() => navigate(-1)}
              className="flex gap-2.5 items-center justify-center"
            >
              Preencher Outro Formulário
            </Button>
          </div> */}
        </div>
      </section>

      <aside className="flex overflow-hidden items-center h-full rounded-2xl min-w-60 w-[413px]">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/a957b64922e04ac2a23d8b53cd42fbd2/caf2e5edb86f8dd7ab636f9d36fad6bb5b30fb10?placeholderIfAbsent=true"
          alt="Decorative side image"
          className="object-contain self-stretch my-auto aspect-[0.57] min-w-60 w-[413px]"
        />
      </aside>
    </main>
  );
} 